export const debounce = (
  callback: { (): void },
  wait: number,
): { (): void } => {
  let timer: number;

  return () => {
    clearTimeout(timer);
    timer = setTimeout(callback, wait);
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const newDebounce = (func: Function, delay: number) => {
  let setTimoutInstance: any;

  // eslint-disable-next-line func-names
  return function (...args: any[]): void {
    if (setTimoutInstance) clearTimeout(setTimoutInstance);
    setTimoutInstance = setTimeout(() => func.apply('', args), delay);
  };
};
